// Top-level shell + router for the merchant portal.
// Routes are registry-driven — see shell/navRegistry.ts (§14.1).
// Only pre-auth routes (SignIn, Phase 7) live outside AdminLayout.

import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from '@/shell/AppRoutes'

export function App() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="flex h-screen items-center justify-center text-muted-foreground">
            Loading…
          </div>
        }
      >
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  )
}
